/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * The type of auth support:
 *   * RFID
 *   * HID
 *   * LICENCE_PLATE
 *   * CODE
 *   * QR_CODE
 *   * UNKNOWN
 */
export enum AuthSupportType {
  RFID = 'RFID',
  HID = 'HID',
  LICENCE_PLATE = 'LICENCE_PLATE',
  CODE = 'CODE',
  QR_CODE = 'QR_CODE',
  UNKNOWN = 'UNKNOWN'
}
